<template>
	<nav class="c-page-header-breadcrumbs">
		<ul class="c-page-header-breadcrumbs__list">
			<li
				v-for="(crumb, idx) in breadcrumbs"
				:key="crumb.path + idx"
				class="c-page-header-breadcrumbs__item"
			>
				<router-link :to="crumb.path" class="c-page-header-breadcrumbs__link">
					<svg
						v-if="crumb.name === 'Tag manager'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M20.8844 10.6984L16.5986 5.69842C16.2187 5.25513 15.664 5 15.0801 5H4C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H15.0801C15.664 19 16.2187 18.7449 16.5986 18.3016L20.8844 13.3016C21.5263 12.5526 21.5263 11.4474 20.8844 10.6984Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
						<path
							d="M16.5 12C16.5 12.8284 15.8284 13.5 15 13.5C14.1716 13.5 13.5 12.8284 13.5 12C13.5 11.1716 14.1716 10.5 15 10.5C15.8284 10.5 16.5 11.1716 16.5 12Z"
							stroke="currentColor"
							stroke-width="2"
						/>
					</svg>
					<svg
						v-if="crumb.name === 'Library'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9.5 16.5V20H5C4.44772 20 4 19.5523 4 19V9.53986C4 9.20293 4.16966 8.88866 4.45134 8.70381L11.4513 4.11006C11.7845 3.89146 12.2155 3.89146 12.5487 4.11006L19.5487 8.70381C19.8303 8.88866 20 9.20293 20 9.53986V19C20 19.5523 19.5523 20 19 20H14.5V16.5C14.5 15.1193 13.3807 14 12 14C10.6193 14 9.5 15.1193 9.5 16.5Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linejoin="round"
						/>
					</svg>
					<svg
						v-if="crumb.name === 'Brand Tracker'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M16 7.19956C14.9554 6.44633 13.657 6 12.25 6C8.79822 6 6 8.68629 6 12C6 15.3137 8.79822 18 12.25 18C13.657 18 14.9554 17.5537 16 16.8004M17.8667 20.0007C16.2093 21.2561 14.1491 22 11.9167 22C6.43984 22 2 17.5228 2 12C2 6.47715 6.43984 2 11.9167 2C14.1491 2 16.2093 2.74389 17.8667 3.99927C18.2444 4.25877 18.5 4.5 18.5 5M14 10L20.5 3.5M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
							stroke="currentColor"
							stroke-linecap="round"
							stroke-width="2"
						/>
					</svg>
					<svg
						v-if="crumb.name === 'Multiplayer'"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						aria-hidden="true"
						role="img"
						x="256"
						y="256"
						class="iconify iconify--ion"
						viewBox="0 0 512 512"
					>
						<path
							stroke-width="2"
							fill="currentColor"
							d="M483.13 245.38C461.92 149.49 430 98.31 382.65 84.33A107.13 107.13 0 0 0 352 80c-13.71 0-25.65 3.34-38.28 6.88C298.5 91.15 281.21 96 256 96s-42.51-4.84-57.76-9.11C185.6 83.34 173.67 80 160 80a115.74 115.74 0 0 0-31.73 4.32c-47.1 13.92-79 65.08-100.52 161C4.61 348.54 16 413.71 59.69 428.83a56.62 56.62 0 0 0 18.64 3.22c29.93 0 53.93-24.93 70.33-45.34c18.53-23.1 40.22-34.82 107.34-34.82c59.95 0 84.76 8.13 106.19 34.82c13.47 16.78 26.2 28.52 38.9 35.91c16.89 9.82 33.77 12 50.16 6.37c25.82-8.81 40.62-32.1 44-69.24c2.57-28.48-1.39-65.89-12.12-114.37ZM208 240h-32v32a16 16 0 0 1-32 0v-32h-32a16 16 0 0 1 0-32h32v-32a16 16 0 0 1 32 0v32h32a16 16 0 0 1 0 32Zm84 4a20 20 0 1 1 20-20a20 20 0 0 1-20 20Zm44 44a20 20 0 1 1 20-19.95A20 20 0 0 1 336 288Zm0-88a20 20 0 1 1 20-20a20 20 0 0 1-20 20Zm44 44a20 20 0 1 1 20-20a20 20 0 0 1-20 20Z"
						></path>
					</svg>
					<svg
						v-if="crumb.name === 'Boards'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5 6H19M7 3H17M5 21H19C20.1046 21 21 20.1046 21 19V11C21 9.89543 20.1046 9 19 9H5C3.89543 9 3 9.89543 3 11V19C3 20.1046 3.89543 21 5 21Z"
							stroke="currentColor"
							stroke-linecap="round"
							stroke-width="2"
						/>
					</svg>
					<svg
						v-if="crumb.name === 'AI Generations'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M10 11C10 9.89543 10.8954 9 12 9H20C21.1046 9 22 9.89543 22 11V19C22 20.1046 21.1046 21 20 21H12C10.8954 21 10 20.1046 10 19V11ZM15.4142 19H20V18.4142L18 16.4142L15.4142 19ZM20 15.5858L19.4142 15C18.6332 14.219 17.3668 14.219 16.5858 15L12.5858 19H12V11H20V15.5858Z"
							fill="currentColor"
						/>
						<path
							d="M15.5 13.25C15.5 13.9404 14.9404 14.5 14.25 14.5C13.5596 14.5 13 13.9404 13 13.25C13 12.5596 13.5596 12 14.25 12C14.9404 12 15.5 12.5596 15.5 13.25Z"
							fill="currentColor"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M1 5C1 3.89543 1.89543 3 3 3H9C10.1046 3 11 3.89543 11 5C11 5.55228 10.5523 6 10 6C9.44772 6 9 5.55228 9 5H7V12C7.55228 12 8 12.4477 8 13C8 13.5523 7.55228 14 7 14H5C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12V5H3C3 5.55228 2.55228 6 2 6C1.44772 6 1 5.55228 1 5Z"
							fill="currentColor"
						/>
						<path
							d="M20.7552 2.15769C20.6501 1.94744 20.35 1.94744 20.2449 2.15769C19.5905 3.46646 19.4665 3.5905 18.1577 4.24488C17.9474 4.35001 17.9474 4.65005 18.1577 4.75518C19.4665 5.40956 19.5905 5.5336 20.2449 6.84237C20.35 7.05262 20.6501 7.05262 20.7552 6.84237C21.4096 5.5336 21.5336 5.40956 22.8424 4.75518C23.0526 4.65005 23.0526 4.35001 22.8424 4.24488C21.5336 3.5905 21.4096 3.46646 20.7552 2.15769Z"
							fill="currentColor"
						/>
						<path
							d="M15.2645 4.16345C15.1555 3.94552 14.8445 3.94552 14.7355 4.16345C14.2499 5.13469 14.1347 5.24991 13.1635 5.73553C12.9455 5.8445 12.9455 6.1555 13.1635 6.26447C14.1347 6.75009 14.2499 6.86532 14.7355 7.83655C14.8445 8.05448 15.1555 8.05448 15.2645 7.83655C15.7501 6.86532 15.8653 6.75009 16.8365 6.26447C17.0545 6.1555 17.0545 5.8445 16.8365 5.73553C15.8653 5.24991 15.7501 5.13468 15.2645 4.16345Z"
							fill="currentColor"
						/>
						<path
							d="M4.75514 16.1577C4.65002 15.9474 4.34998 15.9474 4.24486 16.1577C3.59048 17.4664 3.46644 17.5905 2.15769 18.2449C1.94744 18.35 1.94744 18.65 2.15769 18.7551C3.46644 19.4095 3.59048 19.5336 4.24486 20.8423C4.34998 21.0526 4.65002 21.0526 4.75514 20.8423C5.40952 19.5336 5.53356 19.4095 6.84231 18.7551C7.05256 18.65 7.05256 18.35 6.84231 18.2449C5.53356 17.5905 5.40952 17.4664 4.75514 16.1577Z"
							fill="currentColor"
						/>
					</svg>
					<svg
						v-if="crumb.name === 'MCP Server'"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M11.0533 2.79347C12.4449 1.40182 14.7017 1.40188 16.0933 2.79347L16.2193 2.92628C16.9519 3.73696 17.2448 4.80308 17.1002 5.81886C18.1172 5.67274 19.1848 5.96602 19.9966 6.69972L20.1294 6.82569L20.1714 6.86769L20.2974 7.0005C21.5615 8.3994 21.5197 10.5595 20.1714 11.9077L12.8785 19.2007C12.786 19.2935 12.7858 19.444 12.8785 19.5366L14.3755 21.0337C14.6538 21.312 14.6538 21.7632 14.3755 22.0415C14.0972 22.3196 13.646 22.3198 13.3677 22.0415L11.8707 20.5444C11.2213 19.8951 11.2215 18.8423 11.8707 18.1929L19.1627 10.8999C19.9456 10.1171 19.9952 8.87744 19.3101 8.03761L19.1627 7.8755L19.1207 7.83351C18.2856 6.99932 16.932 6.99885 16.0972 7.83351L10.0914 13.8394C10.085 13.8458 10.0765 13.8499 10.0699 13.856L10.0035 13.9234C9.72519 14.2014 9.27393 14.2014 8.99566 13.9234C8.71756 13.6451 8.71763 13.1939 8.99566 12.9155L15.0855 6.82569C15.9205 5.99069 15.9205 4.63629 15.0855 3.80128C14.2505 2.96644 12.8961 2.96629 12.0611 3.80128L3.99761 11.8648C3.71926 12.143 3.2681 12.1431 2.9898 11.8648C2.71179 11.5864 2.71167 11.1352 2.9898 10.8569L11.0533 2.79347Z"
							fill="currentColor"
						/>
						<path
							d="M13.0777 4.80909C13.356 4.53092 13.8072 4.53098 14.0855 4.80909C14.3638 5.0874 14.3637 5.53856 14.0855 5.81691L8.12164 11.7808C7.28687 12.6156 7.28712 13.9691 8.12164 14.8042C8.95667 15.6392 10.311 15.6392 11.146 14.8042L17.1099 8.84132C17.3882 8.56315 17.8394 8.56321 18.1177 8.84132C18.3956 9.11965 18.3958 9.57091 18.1177 9.84913L12.1539 15.813C10.7622 17.2045 8.50553 17.2044 7.11382 15.813C5.72238 14.4213 5.72225 12.1646 7.11382 10.773L13.0777 4.80909Z"
							fill="currentColor"
						/>
					</svg>
					<svg
						v-if="crumb.name === 'Profile'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M6.11594 18.8103C7.44562 17.0943 9.50054 16 12 16C14.4995 16 16.5544 17.0943 17.8841 18.8103M6.11594 18.8103C7.69368 20.1747 9.75046 21 12 21C14.2495 21 16.3063 20.1747 17.8841 18.8103M6.11594 18.8103C4.20753 17.16 3 14.721 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 14.721 19.7925 17.16 17.8841 18.8103M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linejoin="round"
						/>
					</svg>

					<span>
						{{ crumb.name }}
					</span>
				</router-link>
				<!-- <span v-else class="c-page-header-breadcrumbs__current">
					{{ crumb.name }}
				</span> -->
				<svg
					v-if="idx < breadcrumbs.length - 1"
					class="c-page-header-breadcrumbs__divider"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M10 16L13.4697 12.5303C13.7626 12.2374 13.7626 11.7626 13.4697 11.4697L10 8"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			</li>
		</ul>
	</nav>
</template>

<script>
export default {
	props: {
		title: {},
	},

	computed: {
		breadcrumbs() {
			let segments = this.$route.path.split('/').filter(Boolean);

			segments.splice(1);

			const crumbs = [];

			// build each crumb’s path and prettified name
			let currentPath = '';
			segments.forEach((seg) => {
				currentPath += `/${seg}`;
				let name = seg
					.split('-')
					.map((w) => w.charAt(0).toUpperCase() + w.slice(1))
					.join(' ');
				if (name === 'Brands') {
					name = 'Brand Tracker';
				}
				if (this.title) {
					name = this.title;
				}
				crumbs.push({ name, path: currentPath });
			});

			if (crumbs.length === 0) {
				crumbs.push({ name: 'Library', path: '/' });
			}

			if (this.$route.name === 'Board') {
				let slug = this.$route.params.slug;
				if (slug) {
					let board = this.$store.getters['boards/boardBySlug'](slug);
					if (board) {
						crumbs.push({
							name: board.name,
							path: `/boards/${slug}`,
						});
					}
				}
			}

			if (this.$route.name === 'BrandsSlug') {
				let slug = this.$route.params.slug;
				if (slug) {
					crumbs.push({
						name: slug,
						path: `/brands/${slug}`,
					});
				}
			}

			return crumbs;
		},
	},
};
</script>

<style lang="scss">
.c-page-header-breadcrumbs {
	padding-bottom: 0.5rem;
	width: 100%;
	max-width: 100%;
	overflow-x: hidden;

	a {
		color: var(--color-font);
	}

	&__list {
		min-height: 24px;
		list-style: none;
		margin: 0;
		padding: 0;
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		white-space: nowrap;
	}

	&__item {
		display: flex;
		align-items: center;
		margin: 0;
		padding-left: 0;
		font-weight: 500;

		&:before {
			content: none;
		}
	}

	&__link {
		display: flex;
		align-items: center;
		opacity: 0.75;
		text-decoration: none;
		font-size: var(--font-size-sm);

		svg {
			width: 20px;
			height: 20px;
			margin-right: var(--margin);
		}

		&:hover,
		&:active,
		&:focus {
			text-decoration: none !important;
			opacity: 1;
			color: var(--color-primary);
		}

		&.router-link-exact-active {
			opacity: 1;
		}
	}

	&__current {
		opacity: 1;
	}

	&__divider {
		margin: 0 0.25rem;
		opacity: 0.75;
	}
}
</style>
